import * as React from 'react';

function XMLIcon(props) {
  return (
    <svg width="40" height="40" viewBox="0 0 34.807 43.259" {...props}>
      <g
        fill="#fbd38d"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19.516.5H4.726A4.226 4.226 0 00.5 4.726v33.807a4.226
        4.226 0 004.226 4.226h25.355a4.226 4.226 0 004.226-4.226V15.291l-6.89-6.89z" />
        <path d="M18.516.5v14.791h14.791" />
      </g>
      <text
        transform="translate(5.5 32.5)"
        fontSize={11}
        fontWeight={700}
      >
        <tspan x={0} y={0}>
          {'XML'}
        </tspan>
      </text>
    </svg>
  );
}

export default XMLIcon;
